import httpService from '@/services/httpService'

export const types = {
  ADD_IMPORT_DATA: 'import/ADD_IMPORT_DATA'
}

const state = {
  imports: []
}

const mutations = {
  [types.ADD_IMPORT_DATA]: function (state, imports) {
    state.imports = imports
  }
}

const actions = {
  getImportData: async function ({ commit, dispatch }, { clientId, filters }) {
    const params = { filters: JSON.stringify(filters) }
    const response = await httpService.get(`/importer/${clientId}`, { params })
    if (!response) {
      commit(types.ADD_IMPORT_DATA, [])
      return []
    }
    commit(types.ADD_IMPORT_DATA, response.data)
    return response.data
  },
  createNewImport: function ({ commit }, { clientId, record }) {
    return httpService.post(`/importer/${clientId}`, record,
      {
        isFormData: true,
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        successMessage: 'Import successful',
        raiseError: true,
        cancelErrorMessage: true
      })
  },
  getImportOptions: async function ({ commit , dispatch}) {
    const response = await httpService.get('/importer/options')
    return response.data
  },
  downloadImportedFile: async function ({ commit, dispatch }, params) {
    await httpService.get('/importer/download', { params, responseType: 'arraybuffer' })
      .then((response) => {
        const downloadUrl = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = downloadUrl
        const contentDisposition = response.headers['content-disposition']
        let fileName = 'unknown'
        if (contentDisposition) {
          const fileNameMatch = contentDisposition.match(/filename=(.+)/)
          if (fileNameMatch.length === 2) {
            fileName = fileNameMatch[1]
          }
        }
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        link.remove()
      })
    return true
  },
  getImportReview: async function ({ commit, dispatch }, params) {
    params = {
      id: params
    }
    const response = await httpService.get('/importer/review', { params })
    return response
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
